import React, { useState } from 'react';
import { Input, Form, InputNumber, Select, Modal, Button, Spin, notification } from 'antd';
import { Pricing, allLevelTypes, allVehiculeTypes } from '../../../shared/types';
import { handleFormChange, layoutEdit, validateMessages } from '../../../shared/Utils';
import { useCreatePricingMutation } from '../../../GraphQL/hooks/useCreatePricingMutation';

const PricingCreateModal = ({ isOpen, onRequestClose, updateList }) => {
    const [form] = Form.useForm();
    const [formError, setFormError] = useState(false);

    const { mutation, loading: creating } = useCreatePricingMutation();

    const handleCommit = async () => {
        try {
            const values = await form.validateFields();
            if (values) {
                mutation({ ...values })
                    .then(() => {
                        onRequestClose(false);
                        updateList();
                    })
                    .finally(() => {
                        notification.success({
                            message: 'Pricing updated successfully',
                            description: 'The pricing has been updated successfully.',
                        });
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Failed to update pricing',
                            description: 'An error occurred while updating the pricing.',
                        });

                        console.error('Failed to update pricing:', err);
                    });
            } else {
                notification.error({
                    message: 'Form validation failed',
                    description: 'Please fill in all required fields correctly.',
                });
                console.error('Failed: Form is empty or has errors');
            }
        } catch (errorInfo) {
            notification.error({
                message: 'Form validation error',
                description: 'Please ensure all fields are filled out correctly.',
            });
            console.error('Failed: Form validation error', errorInfo);
        }
    };

    const handleCancel = () => {
        onRequestClose(false);
    };

    return (
        <Modal
            forceRender
            title="Add Price"
            open={isOpen}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="create" type="primary" onClick={handleCommit} disabled={formError}>
                    Create
                </Button>,
            ]}
        >
            <Spin spinning={creating}>
                <Form<Pricing>
                    {...layoutEdit}
                    form={form}
                    autoComplete="off"
                    name="nest-messages"
                    onFieldsChange={() => {
                        setFormError(handleFormChange(form));
                    }}
                    validateMessages={validateMessages}
                >
                    <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                        <Input type="textarea" placeholder="Name of the price" style={{ width: '60%' }} />
                    </Form.Item>
                    <Form.Item name="note" label="Note" rules={[{ required: true }]}>
                        <Input type="textarea" style={{ width: '60%' }} />
                    </Form.Item>
                    <Form.Item name="minutePrice" label="Minute price" rules={[{ required: true }]}>
                        <InputNumber type="number" />
                    </Form.Item>
                    <Form.Item name="unlockPrice" label="Unlock price" rules={[{ required: true }]}>
                        <InputNumber type="number" />
                    </Form.Item>
                    <Form.Item name="vehiculeType" label="Vehicule type" rules={[{ required: true }]}>
                        <Select placeholder="Select type of vehicule" style={{ width: '60%' }}>
                            {(allVehiculeTypes ?? []).map((type) => (
                                <Select.Option key={type} value={type}>
                                    {type}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name="level" label="Level" rules={[{ required: true }]}>
                        <Select placeholder="Select type of level" style={{ width: '60%' }}>
                            {(allLevelTypes ?? []).map((type) => (
                                <Select.Option key={type} value={type}>
                                    {type}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );
};

export default PricingCreateModal;
